import { Controller } from "@hotwired/stimulus"

// This controller manages the autosave snackbar counter and listens for email-result-revealed events
export default class extends Controller {
  static get targets() {
    return ["bar", "message"]
  }

  static get values() {
    return { counter: Number }
  }

  handleEmailRevealed() {
    this.counterValue += 1
    this.updateMessageDisplay()
    this.showSnackbar()
  }

  updateMessageDisplay() {
    if (this.hasMessageTarget && this.counterValue > 0) {
      this.messageTarget.innerHTML = i18n.t("js.front.autosave_snackbar.contacts_saved_html", { count: this.counterValue })
    }
  }

  showSnackbar() {
    if (this.hasBarTarget) {
      setTimeout(() => {
        this.barTarget.classList.add("is-visible")
      }, 100)
    }
  }
}
